import { render, staticRenderFns } from "./pro_dual.vue?vue&type=template&id=b7d75d02&scoped=true&"
import script from "./pro_dual.vue?vue&type=script&lang=js&"
export * from "./pro_dual.vue?vue&type=script&lang=js&"
import style0 from "./pro_dual.vue?vue&type=style&index=0&id=b7d75d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d75d02",
  null
  
)

export default component.exports